import { ValidMimeTypes } from './enums';

export const IMGS_MYME_TYPE = [
  ValidMimeTypes.bmp,
  ValidMimeTypes.gif,
  ValidMimeTypes.heic,
  ValidMimeTypes.heif,
  ValidMimeTypes.jpeg,
  ValidMimeTypes.png,
  ValidMimeTypes.tiff,
  ValidMimeTypes.webp,
];
